import React from 'react'
import styled from 'styled-components'
import { WithAuth as Root } from '@/components/Root'
import { NotificationsTable } from '@/components/tables/NotificationsTable'
import { Layout, PageHeader } from 'antd'

const pageTitle = 'PUSH通知履歴'

export default () => (
  <Root title={pageTitle}>
    <Layout>
      <StyledPageHeader title={pageTitle} />
      <NotificationsTable />
    </Layout>
  </Root>
)

const StyledPageHeader = styled(PageHeader)`
  margin: 16px 0;
  background-color: #fff;
`
